import * as types from "./types";

import {
  getServiceTemplatesListAxios,
  getServiceTemplateByIDAxios,
  postServiceTemplateAxios,
  putServiceTemplateAxios,
  deleteServiceTemplateAxios,
  postServiceTemplateDocumentAxios,
  putServiceTemplateDocumentAxios,
  getServiceTemplateDocumentsAxios,
  //getServiceTemplateDocumentAxios,
  getServiceOrderListAxios,
  getServiceOrderByIDAxios,
  postServiceOrderAxios,
  putServiceOrderAxios,
  postServiceOrderSignatureAxios,
  getServiceOrderSignatureByIdAxios,
  postServiceOrderDocumentAxios,
  putServiceOrderDocumentAxios,
  getServiceOrderDocumentsAxios,
  getServiceOrderDocumentAxios,
  removeServiceOrderDocumentAxios,
  putServiceOrderApproveOrCancelAxios,
  putServiceOrderRescheduleAxios,
  getServiceTemplateByReferenceNoAxios,
  putApproveOrCancelAxios,
  putRescheduleAxios,
  getStaffForTemplatesListAxios,

  //#region Timesheet
  getServiceTimesheetListAxios,
  getServiceTimesheetByIDAxios,
  postServiceTimesheetAxios,
  putServiceTimesheetAxios,
  postImportTimesheetAxios
  
  //#endregion
} from "./services";

//#region Service Template

export async function getServiceTemplateListAction({ commit }) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    const { data } = await getServiceTemplatesListAxios();
    commit(types.GET_SERVICEREQUESTS_LIST, data.result.data);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}


export async function getStaffForTemplateListAction({ commit }) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    const { data } = await getStaffForTemplatesListAxios();
    commit(types.GET_STAFFSERVICEREQUESTS_LIST, data);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function getServiceTemplateByIDAction({ commit }, payload) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    const { data } = await getServiceTemplateByIDAxios(payload);
    if (data != null && data.success == true && data.result != null && data.result.succeeded == true) {
      commit(types.GET_SERVICEREQUESTSBYID, data.result.data);
    }
  } catch (e) {
    console.log("The Error: ", e);
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function getServiceTemplateByReferenceNoAction({ commit }, payload) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    const { data } = await getServiceTemplateByReferenceNoAxios(payload);
    if (data != null && data.success == true && data.result != null && data.result.succeeded == true) {
      commit(types.GET_SERVICEREQUESTSBYREFERENCENO, data.result.data);
    }
  } catch (e) {
    console.log("The Error: ", e);
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function addServiceTemplateAction({commit}, {payload}) {
    commit(types.LOADING_SERVICEREQUESTS, true);
    try {
        const {data} = await postServiceTemplateAxios(payload);
        payload.id = data.id;
        commit(types.ADD_SERVICEREQUESTS, payload);
    }
    catch(e) {
        throw e;
     }
    finally{
     commit(types.LOADING_SERVICEREQUESTS, false);
    }
  }

export async function updateServiceTemplateAction({ commit }, { payload }) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    const { data } = await putServiceTemplateAxios(payload);
    payload.id = data.id;
    commit(types.UPDATE_SERVICEREQUESTS, payload);
  } catch (e) {
    console.log("Api Error: ", e);
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function removeServiceTemplateAction({ commit }, payload) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    await deleteServiceTemplateAxios(payload);
    commit(types.REMOVE_SERVICEREQUESTS, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function removeServiceOrderDocumentAction({ commit }, payload) {
  commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, true);
  try {
    await removeServiceOrderDocumentAxios(payload);
    commit(types.REMOVE_ORDER_DOCUMENT, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, false);
  }
}

export async function postServiceTemplateDocumentAction({ commit }, payload) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    const { data } = await postServiceTemplateDocumentAxios(payload);
    commit(types.SERVICEDOCUMENT_ADD_FILE, payload);
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function putServiceTemplateocumentAction({ commit }, payload) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    await putServiceTemplateDocumentAxios(payload);
    commit(types.SERVICEDOCUMENT_UPDATE_FILE, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function getServiceTemplateFileAction({ commit }, payload) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    const { data } = []; //await getServiceTemplateDocumentAxios(payload);
    commit(types.SERVICEDOCUMENT_GET_FILE, data.result);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function getServiceTemplateFileListAction({commit}, OrderTemplateId) {
    commit(types.LOADING_SERVICEREQUESTS, true);
    try {
        const {data} = await getServiceTemplateDocumentsAxios(OrderTemplateId);
            commit(types.SERVICEDOCUMENT_GET_FILE_LIST, data.result.data);
            return data.result.data;
    }
    catch(e) {
       
        throw e;
    }
    finally{
        commit(types.LOADING_SERVICEREQUESTS, false);
    }
}
//#endregion

//#region Service Order

export async function getServiceOrderListAction({ commit }, status = null) {
  commit(types.LOADING_SERVICEORDERREQUESTS, true);
  try {
    const { data } = await getServiceOrderListAxios(status);
    commit(types.GET_SERVICEORDERREQUESTS_LIST, data.data);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEORDERREQUESTS, false);
  }
}

export async function getServiceOrderByIDAction({ commit }, payload) {
  commit(types.LOADING_SERVICEORDERREQUESTS, true);
  try {
    const { data } = await getServiceOrderByIDAxios(payload);
    commit(types.GET_SERVICEORDERREQUESTSBYID, payload);
    return data.result.data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEORDERREQUESTS, false);
  }
}

export async function postServiceOrderAction({ commit }, {payload}) {
  commit(types.LOADING_SERVICEORDERREQUESTS, true);
  try {
    const { data } = await postServiceOrderAxios(payload);
    commit(types.ADD_SERVICEORDERREQUESTS, payload);
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEORDERREQUESTS, false);
  }
}

export async function putServiceOrderAction({ commit }, {payload}) {
  commit(types.LOADING_SERVICEORDERREQUESTS, true);
  try {
    const { data } = await putServiceOrderAxios(payload);
    payload.id = data.id;
    commit(types.UPDATE_SERVICEORDERREQUESTS, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEORDERREQUESTS, false);
  }
}

export async function postServiceOrderSignatureAction({ commit }, payload) {
  commit(types.LOADING_SERVICEORDERREQUESTS, true);
  try {
    await postServiceOrderSignatureAxios(payload);
    commit(types.ADD_SERVICEORDERREQUESTSSIGNATURE, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEORDERREQUESTS, false);
  }
}

export async function getServiceOrderSignatureByIdAction({ commit }, payload) {
  commit(types.LOADING_SERVICEORDERREQUESTS, true);
  try {
    await getServiceOrderSignatureByIdAxios(payload);
    commit(types.GET_SERVICEORDERREQUESTSSIGNATURE, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEORDERREQUESTS, false);
  }
}

export async function postServiceOrderDocumentAction({ commit }, payload) {
  commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, true);
  try {
    await postServiceOrderDocumentAxios(payload);
    commit(types.SERVICEORDERDOCUMENT_ADD_FILE, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, false);
  }
}

export async function putServiceOrderDocumentAction({ commit }, payload) {
  commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, true);
  try {
    await putServiceOrderDocumentAxios(payload);
    commit(types.SERVICEORDERDOCUMENT_UPDATE_FILE, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, false);
  }
}

export async function getServiceOrderDocumentAction({ commit }) {
  commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, true);
  try {
    const { data } = await getServiceOrderDocumentAxios();
    commit(types.SERVICEORDERDOCUMENT_GET_FILE, data.result);
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, false);
  }
}

export async function getServiceOrderDocumentsAction({ commit }, payload) {
  commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, true);
  try {
    const { data } = await getServiceOrderDocumentsAxios(payload);
    commit(types.SERVICEORDERDOCUMENT_GET_FILE_LIST, data.result.data);
    //console.log("filesssssssss", data.result.data);
    return data.result;
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDERDOCUMENT_LOADING_FILE, false);
  }
}

export async function putServiceOrderApproveOrCancelAction(
  { commit },
  payload
) {
  commit(types.LOADING_SERVICEORDERREQUESTS, true);
  try {
    const { data } = await putServiceOrderApproveOrCancelAxios(payload);
    payload.id = data.id;
    commit(types.GET_SERVICEORDERREQUESTSAPPROVEORCANCEL, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEORDERREQUESTS, false);
  }
}

export async function putServiceOrderRescheduleAction({ commit }, payload) {
  commit(types.LOADING_SERVICEORDERREQUESTS, true);
  try {
    const { data } = await putServiceOrderRescheduleAxios(payload);
    payload.id = data.id;
    commit(types.GET_SERVICEORDERREQUESTSRESCHEDULE, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEORDERREQUESTS, false);
  }
}

//#endregion

//#region Timesheet

export async function getServiceTimesheetListAction({ commit }, modulereference) {
  commit(types.SERVICEORDER_TIMESHEET_LOADING, true);
  try {
    const { data } = await getServiceTimesheetListAxios(modulereference);
    commit(types.SERVICEORDER_GET_TIMESHEET_LIST, data.data);
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDER_TIMESHEET_LOADING, false);
  }
}

export async function getServiceTimesheetAction({ commit }, {modulereference, id}) {
  commit(types.SERVICEORDER_TIMESHEET_LOADING, true);
  try {
    const { data } = await getServiceTimesheetByIDAxios(modulereference, id);

    if (data && data.data) {
      commit(types.SERVICEORDER_GET_TIMESHEET, data.data);
    } else {
      console.warn('API data is missing data property.');
    }
    
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDER_TIMESHEET_LOADING, false);
  }
}

export async function postServiceTimesheetAction({ commit }, payload) {
  commit(types.SERVICEORDER_TIMESHEET_LOADING, true);
  try {
    const { data } = await postServiceTimesheetAxios(payload);
    commit(types.SERVICEORDER_ADD_TIMESHEET, data.result);
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDER_TIMESHEET_LOADING, false);
  }
}

export async function putServiceTimesheetAction({ commit }, payload) {
  commit(types.SERVICEORDER_TIMESHEET_LOADING, true);
  try {
    const { data } = await putServiceTimesheetAxios(payload);
    console.log('test 001', payload);
    commit(types.SERVICEORDER_UPDATE_TIMESHEET, payload);
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.SERVICEORDER_TIMESHEET_LOADING, false);
  }
}

//#endregion

export async function approveOrCancelAction({ commit }, {payload}) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    await putApproveOrCancelAxios(payload);
    commit(types.APPROVE_OR_CANCEL_SERVICEREQUESTS, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.APPROVE_OR_CANCEL_SERVICEREQUESTS, false);
  }
}

export async function rescheduleAction({ commit }, {payload}) {
  commit(types.LOADING_SERVICEREQUESTS, true);
  try {
    await putRescheduleAxios(payload);
    commit(types.RESCHEDULE_SERVICEREQUESTS, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_SERVICEREQUESTS, false);
  }
}

export async function importTimesheetAction({ commit }, payload) {
  commit(types.SERVICEORDER_TIMESHEET_LOADING, true);
  try {
    const { data } = await postImportTimesheetAxios(payload);
    (payload);
    commit(types.IMPORT_TIMESHEET, payload);
    return data;
  }
  catch (e) {
    throw e;
  }
  finally {
    commit(types.SERVICEORDER_TIMESHEET_LOADING, false);
  }
}